/**
 * Hook pour gérer la configuration de l'application (admin)
 * @module admin/hooks/useAppConfig
 */

import { useState, useEffect, useCallback } from 'react';
import { getAppConfig, updateAppConfig } from '../services/appConfigService';

export const useAppConfig = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAppConfig();
      setConfig(data);
    } catch (err) {
      setError(err.message || 'Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  }, []);

  const updateConfig = useCallback(async (updates) => {
    setSaving(true);
    setError(null);
    try {
      const data = await updateAppConfig(updates);
      setConfig(data);
      return { success: true };
    } catch (err) {
      setError(err.message || 'Erreur lors de la mise à jour');
      return { success: false, error: err.message };
    } finally {
      setSaving(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return {
    config,
    loading,
    saving,
    error,
    fetchConfig,
    updateConfig,
  };
};
